export function formatCpf(event) {

    let value = event.srcElement.value;

    value = value.replace(/\D/g, "")
    value = value.replace(/(\d{3})(\d)/, "$1.$2")
    value = value.replace(/(\d{3})(\d)/, "$1.$2")
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2")

    event.srcElement.value = value.substr(0, 14)
}

export function onlyNumbers(event) {

    let value = event.srcElement.value;

    value = value.replace(/\D/g, "")

    event.srcElement.value = value;
}

export function formatDay(event) {

    let value = event.srcElement.value;

    value = value.replace(/\D/g, "")
    value = value.replace(/(\d{2})(\d)/, "$1")

    event.srcElement.value = value;
}

export function formatMonth(event) {

    let value = event.srcElement.value;

    value = value.replace(/\D/g, "")
    value = value.replace(/(\d{2})(\d)/, "$1")

    event.srcElement.value = value;
}

export function formatYear(event) {

    let value = event.srcElement.value;

    value = value.replace(/\D/g, "")
    value = value.replace(/(\d{4})(\d)/, "$1")

    event.srcElement.value = value;
}

export function formatPhoneNumber(event) {
    let value = event.srcElement.value;

    value = value.replace(/\D/g, "")
    value = value.replace(/^(\d\d)(\d)/g, "($1) $2")
    value = value.replace(/(\d{4})(\d)/, "$1-$2")

    event.srcElement.value = value.substr(0, 14)
}

export function formatLandLine(event) {
    let value = event.srcElement.value;

    value = value.replace(/\D/g, "")
    value = value.replace(/^(\d\d)(\d)/g, "($1) $2")
    value = value.replace(/(\d{4})(\d)/, "$1-$2")

    event.srcElement.value = value.substr(0, 13)
}

export function formatDate(event) {
    let value = event.srcElement.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");

    value = value.replace(/(\d{2})(\d{2})$/, "$1$2");

    event.srcElement.value = value.substr(0, 10)
}

export function formatUpdatedDate(date) {

    let data = new Date(date);
    let dia = addZeroIfNeeds(data.getDate());
    let mes = addZeroIfNeeds(data.getMonth()+1);
    let ano = data.getFullYear();
    let hora = addZeroIfNeeds(data.getHours());
    let minuto = addZeroIfNeeds(data.getMinutes());

    function addZeroIfNeeds(value) {
        let valueString = value.toString();

        if(valueString.length == 1) {
           return valueString = `0${valueString.toString()}`
        } else {
            return value;
        }
    }

    return `${dia}/${mes}/${ano} às ${hora}:${minuto}`;
}

export function formatBirthDate(date) {
    let dob = date.split('T')[0].split('-').reverse();
    return `${dob[0]}/${dob[1]}/${dob[2]}`;

    // function addZeroIfNeeds(value) {
    //     let valueString = value.toString();

    //     if(valueString.length == 1) {
    //        return valueString = `0${valueString.toString()}`
    //     } else {
    //         return value;
    //     }
    // }

    // return `${dia}/${mes}/${ano}`;
}

export function formatDateHowItWorks(date) {

    let data = new Date(date);
    let dia = addZeroIfNeeds(data.getDate());
    let mes = addZeroIfNeeds(data.getMonth()+1);
    let ano = data.getFullYear();
    let hora = addZeroIfNeeds(data.getHours());
    let minuto = addZeroIfNeeds(data.getMinutes());

    function addZeroIfNeeds(value) {
        let valueString = value.toString();

        if(valueString.length == 1) {
           return valueString = `0${valueString.toString()}`
        } else {
            return value;
        }
    }

    return `${dia}/${mes}/${ano}`;
}

export function formatPostalCode(event) {
    let value = event.srcElement.value;

    value = value.replace(/D/g,"")
    value = value.replace(/^(\d{5})(\d)/,"$1-$2")

    event.srcElement.value = value.substr(0, 9)
}
